import Label from "../../atoms/Label"
import Modal from "../Modal"
import Button from "../../atoms/Button"
import styles from "./index.module.scss"
import { useContext, useEffect, useState } from "react"

import {
  calculate,
  formulaToText,
  getCurrentField,
  getVariablesOnFormula,
  textToFormula,
} from "../CalcField/logic"
import FieldsContext from "../../../contexts/Fields"
import BoardContext from "../../../contexts/Board"

export default function ModalCalcMemory(props) {
  const { aAllFields } = useContext(FieldsContext)
  const { oCurrentBoard } = useContext(BoardContext)
  const [activityFormulaText, setActivityFormulaText] = useState("")
  const [activityFormulaTextWithValues, setActivityFormulaTextWithValues] = useState("")
  const { isOpen, onClose, aFields, cActivityFormula, cFieldName } = props

  useEffect(() => {
    let cFieldId = cFieldName.split("-")[cFieldName.split("-").length - 1]
    let calcField = aAllFields.find((field) => field.opfd_nid === Number(cFieldId))

    const ModelBoard = oCurrentBoard.board_model || oCurrentBoard.data[0].board_model
    const currentField = getCurrentField(ModelBoard, cFieldId)
    const currentFormula = cActivityFormula || currentField?.ombf_cvalue || ""
    let activityFormula = textToFormula(currentFormula, aAllFields)
    setActivityFormulaText(formulaToText(activityFormula, aFields))
    //replace all
    let formulaVariables = getVariablesOnFormula(currentFormula)
    
    
    let formula = currentFormula
    formulaVariables.forEach((fieldId) => {
      const selectField =
        (aFields && aFields.values?.find((f) => f.opfv_opfd_nid === Number(fieldId))) ||
        []

      const formValue = selectField?.opfv_cvalue || selectField?.selected_option?.opfs_coption_value || "0"
      formula = formula.replace(`'${fieldId}'`, `${formValue}`)
    })
    let result = calculate(formula, () => {})
    let newFormula =
      formula +
      "=" +
      Number(result)
        .toFixed(calcField.opfd_nprecision || 0)
        .replace(".", ",")

    //adicione espaço entre +-/*{}()[]= e ignore , e .
    newFormula = newFormula.replace(/([+\-*/{}()[\]=])/g, " $1 ")

    setActivityFormulaTextWithValues(newFormula)
  }, [cActivityFormula, aFields, aAllFields])

  return (
    <Modal size="sm" isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Header onClose={onClose}>Formula do Cálculo</Modal.Header>
      <Modal.Content>
        <div className={styles.mainContent}>
          <div>
            <Label>Cálculo Configurado</Label>
            <div className={styles.input}>{activityFormulaText}</div>
          </div>
          <div>
            <Label>Memória de Cálculo</Label>
            <div className={styles.input}>{activityFormulaTextWithValues}</div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer className={styles.footer}>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
